import type { ReactNode } from "react";
import { Icon } from "./Icon";

export interface EmptyProps {
  title: string;
  subtitle?: string;
  cta?: ReactNode;
  variant?: "default" | "error";
  icon?: string;
}

export function Empty({
  title,
  subtitle,
  cta,
  variant = "default",
  icon,
}: EmptyProps) {
  const glyph = icon ?? (variant === "error" ? "warn" : "box");
  return (
    <div
      className="empty"
      data-variant={variant}
      style={{
        padding: "64px 20px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 12,
          background:
            variant === "error" ? "var(--err-bg)" : "var(--surface-3)",
          display: "grid",
          placeItems: "center",
          color: variant === "error" ? "var(--err)" : "var(--ink-3)",
          marginBottom: 4,
        }}
      >
        <Icon name={glyph} size={24} stroke={1.4} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600 }}>{title}</div>
      {subtitle && (
        <div
          style={{
            color: "var(--ink-3)",
            fontSize: 13,
            maxWidth: 340,
          }}
        >
          {subtitle}
        </div>
      )}
      {cta && <div style={{ marginTop: 8 }}>{cta}</div>}
    </div>
  );
}
